/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-avatar-size-small: Avatar small size.
 * @prop --sy-avatar-size: Avatar regular size.
 * @prop --sy-avatar-border-radius: Default border radius.
 * @prop --sy-avatar-border-radius-rounded: Avatar border radius.
 * @prop --sy-avatar-color: Avatar font color
 * @prop --sy-avatar-background-color: Avatar background color
 * @prop --sy-avatar-font-size: Avatar font size.
 * @prop --sy-avatar-text-decoration: Avatar text decoration.
 * @prop --sy-avatar-font-family: Avatar font family.
 * @prop --sy-avatar-font-weight: Avatar font weight.
 * @prop --sy-avatar-font-style: Avatar font style.
 * @prop --sy-avatar-font-stretch: Avatar font stretch.
 * @prop --sy-avatar-letter-spacing: Avatar letter spacing.
 * @prop --sy-avatar-line-height: Avatar line height.
 * @prop --sy-avatar-small-font-size: Avatar small font size.
 * @prop --sy-avatar-small-text-decoration: Avatar small text decoration.
 * @prop --sy-avatar-small-font-family: Avatar small font family.
 * @prop --sy-avatar-small-font-weight: Avatar small font weight.
 * @prop --sy-avatar-small-font-style: Avatar small font style.
 * @prop --sy-avatar-small-font-stretch: Avatar small font stretch.
 * @prop --sy-avatar-small-letter-spacing: Avatar small letter spacing.
 * @prop --sy-avatar-small-line-height: Avatar small line height.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--sy-avatar-size, var(--sy-spacer-7));
  height: var(--sy-avatar-size, var(--sy-spacer-7));
  overflow: hidden;
  color: var(--sy-avatar-color, var(--sy-foreground-inverse-emphasis));
  background-color: var(--sy-avatar-background-color, var(--sy-surface-inverse));
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border-radius: var(--sy-avatar-border-radius, var(--sy-border-radius));
  font-size: var(--sy-avatar-font-size, var(--sy-heading-h5-font-size));
  text-decoration: var(--sy-avatar-text-decoration, var(--sy-heading-h5-text-decoration));
  font-family: var(--sy-avatar-font-family, var(--sy-heading-h5-font-family));
  font-weight: var(--sy-avatar-font-weight, var(--sy-heading-h5-font-weight));
  font-style: var(--sy-avatar-font-style, var(--sy-heading-h5-font-style));
  font-stretch: var(--sy-avatar-font-stretch, var(--sy-heading-h5-font-stretch));
  letter-spacing: var(--sy-avatar-letter-spacing, var(--sy-heading-h5-letter-spacing));
  line-height: var(--sy-avatar-line-height, var(--sy-heading-h5-line-height));
}

:host([small]) {
  width: var(--sy-avatar-size-small, var(--sy-spacer-6));
  height: var(--sy-avatar-size-small, var(--sy-spacer-6));
  font-size: var(--sy-avatar-small-font-size, var(--sy-heading-h6-font-size));
  text-decoration: var(--sy-avatar-small-text-decoration, var(--sy-heading-h6-text-decoration));
  font-family: var(--sy-avatar-small-font-family, var(--sy-heading-h6-font-family));
  font-weight: var(--sy-avatar-small-font-weight, var(--sy-heading-h6-font-weight));
  font-style: var(--sy-avatar-small-font-style, var(--sy-heading-h6-font-style));
  font-stretch: var(--sy-avatar-small-font-stretch, var(--sy-heading-h6-font-stretch));
  letter-spacing: var(--sy-avatar-small-letter-spacing, var(--sy-heading-h6-letter-spacing));
  line-height: var(--sy-avatar-small-line-height, var(--sy-heading-h6-line-height));
}

:host([rounded]) {
  border-radius: var(--sy-avatar-border-radius-rounded, var(--sy-border-radius-rounded));
}